(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["full-ingredient-list"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    $(document).on("click", ".see-more", function() {
        console.log("Button clicked.");

        var extraContent = $(".additional");
        var arrow = $(".see-more .arrow");
        var seeMoreText = $(".see-more .text");

        if (extraContent.hasClass("hidden")) {
            extraContent.removeClass("hidden");
            seeMoreText.text("See Less");
            arrow.css("transform", "rotate(180deg)");
        } else {
            extraContent.addClass("hidden");
            seeMoreText.text("See Full Ingredient List");
            arrow.css("transform", "rotate(0deg)");
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-grid"]) return;
  try {
    
  
  
  
  
document.addEventListener('DOMContentLoaded', function() {
    
    const modals = document.querySelectorAll('.modal');
    const overlay = document.getElementById('modal-overlay');
    const infoButtons = document.querySelectorAll('.info-button');
    const closeButtons = document.querySelectorAll('.close');

    function openModal(modalId) {
        const modal = document.getElementById(modalId);
        if (modal) {
            modal.style.display = "block";
            overlay.style.display = "block";
            document.body.style.overflow = "hidden";
        }
    }
    
    function closeModal(modalId) {
        const modal = document.getElementById(modalId);
        if (modal) {
            modal.style.display = "none";
            overlay.style.display = "none";
            document.body.style.overflow = "auto";
        }
    }

// Bind click event to info buttons
    infoButtons.forEach((button, index) => {
        button.addEventListener('click', () => openModal(`${index + 1}-modal`));
    });

    // Bind click event to close buttons
    closeButtons.forEach((button, index) => {
        button.addEventListener('click', () => closeModal(`${index + 1}-modal`));
    });

    // Bind click event to overlay
    if (overlay) {
        overlay.addEventListener('click', () => {
            modals.forEach((modal, index) => {
                closeModal(`${index + 1}-modal`);
            });
        });
    }

    const prevButtons = document.querySelectorAll('.prev');
    const nextButtons = document.querySelectorAll('.next');

    prevButtons.forEach((button, index) => {
        button.addEventListener('click', (event) => {
            event.stopPropagation(); // Prevents the modal from closing
            plusSlides(-1); // Go to the previous slide
        });
    });

    nextButtons.forEach((button, index) => {
        button.addEventListener('click', (event) => {
            event.stopPropagation(); // Prevents the modal from closing
            plusSlides(1); // Go to the next slide
        });
    });

    let slideIndex = 1;

    function plusSlides(n) {
        showSlides(slideIndex += n);
    }

    function showSlides(n) {
        const slides = document.querySelectorAll(".modal");
        const totalSlides = slides.length;

        for (let i = 0; i < totalSlides; i++) {
            closeModal(`${i + 1}-modal`);
        }

        if (n > totalSlides) {
            slideIndex = 1;
        } else if (n < 1) {
            slideIndex = totalSlides;
        }

        openModal(`${slideIndex}-modal`);
    }
});

  } catch(e) { console.error(e); }
})();
      })();
